import { BaseResponse } from './base.response';

export class ItemAvailabilityResponse extends BaseResponse {

  public availableDate: Date;

}
